export interface PaginatedResponse<T> {
  count: number;
  next: boolean;
  previous: boolean;
  results: T[];
}

export interface ResponsePage<T> {
  count: number;
  pages: number;
  hasNext: boolean;
  hasPrevious: boolean;
  results: T[];
}

export interface PaginatedQueryParams {
  limit?: number;
  offset?: number;
}

export enum StatusSet {
  INVOICE = "invoice",
  CONTACT = "contact",
}

export enum UIStatus {
  OK = "ok",
  ERROR = "error",
  NEUTRAL = "neutral",
  SUCCESS = "success",
  WARNING = "warning",
  ATTENTION = "attention",
}

export interface UIStatusProps {
  backgroundColor: string;
  borderColor: string;
  fillColor: string;
  textColor?: string;
  strippedFill?: string;
}

export interface SimpleAction {
  label: string;
  onClick: () => void;
}

export type VoidFunction = () => void;
